<template>
    <div>
		<div class="maxContainer tradingIdeas">
			<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
			<div class="mainTitle text-center my-3">
				<h3> {{ $t('CurrentNews') }}</h3>
			</div> 
			
			<div class="row" >
			  <div class="col-4 d-flex" v-for="(list,index) in currentNews.records" v-if="currentNews.totalRecords > 0  && !load_more_msz" >
				<div class="card d-flex w-100 flex-column"> 
				  <div class="card-body w-100 flex-column d-flex" > 
					<div class="w-100 flex-column flex-grow-one">
					<h5 class="card-title">
					 	{{list.category}}
						<sup  class="badge badge-pill badge-secondary">{{list.symbol}}</sup>
					</h5>
					
					<h4 class="mb-3 green" ><a href="#" @click="newsTab(list.url)"> {{list.title}}</a> </h4>
					<p class="card-text mb-3 " :ref="'less'+index">{{list.description.substring(0,150)}} <span class="showmore" @click="detailDiv(index,'more')">{{$t('showMore')}}</span> </p>
					<p class="card-text mb-3 hide" :ref="'more'+index">{{list.description}} <span class="showmore" @click="detailDiv(index,'less')">{{$t('showLess')}}</span> </p>
					</div>
					<div class="view-likes-block d-flex align-items-center justify-content-between">
					  <div class="currency-info d-flex align-items-center">
						<div class="currency mr-3">
						  {{list.symbol}} <!-- {{list.}} -->
						</div>
						<span class="short">                                                           
						  <span class="badge badge-pill badge-success">{{list.holding_period}}</span>
						</span>
					  </div>
					  <div class="colRight d-flex align-items-center">
						<div class="date d-flex align-items-center"><feather type="calendar" class="mr-2"></feather> {{dateFunction(list.published)}}</div>
					  </div>
					</div> 
				  </div>
				</div>
			  </div> 
				<div class="col-4" v-for="n in 3" v-if="pageLoader"> 
					<div class="card cardLoading"> 
						<h5 class="card__title loadingltr"></h5> 
						<div class="card__image loadingltr"></div>  
						<p class="card__description loadingltr mb-3"> </p>
						<div class="view-likes-block d-flex align-items-center justify-content-between">
							<div class="currency-info d-flex align-items-center">
								<div class="currency card__title loadingltr mr-3"></div>
								<span class="short">
								  <span class="badge badge-pill badge-success"></span>
								</span>
							</div>
							<div class="colRight card__title loadingltr d-flex align-items-center">
								<div class="views d-flex align-items-center"></div>
								<div class="date d-flex align-items-center"></div>
							</div>
						</div>  
					</div>
					 
				</div>
			</div>
			<div class="whiteBG border radiusbold p-5 mb-3 justify-content-between align-items-center d-flex" v-if="load_more_msz">
				<img src="../../../../static/fxView/images/manworking.svg" alt="live account" width="400" class="mr-5">
				<div class="lft">
					<h3 class="mb-4" v-html="$t('haveReachedFreeLimit')">
					</h3>
					<span><router-link class="prism_btn btn_sm" to="/create-live-account">{{$t('CreateLiveAccount')}}</router-link></span> 
					<span><a href="#" class="prism_btn btn_sm darkBG ml-2" @click="load_more_msz = false">{{$t('Cancel')}}</a></span> 
				</div> 
			</div>  
			<div class="text-center pt-3 mb-3">
				<a href="#" class="prism_btn btn_sm mb-3" @click="load_more_msz = true"  v-if="parseInt(tradingAccountList.totalLiveAccounts) == 0  && !load_more_msz">{{$t('LoadMore')}}</a>
				<a href="#" class="prism_btn btn_sm mb-3" @click="loadList()" v-else-if="parseInt(tradingAccountList.totalLiveAccounts) > 0">{{$t('LoadMore')}}</a>
				<p> {{ $t('Poweredby') }} <a href="https://portfolios.com/" target="_blank"> {{ $t('PortfoliosCom') }}</a></p>
			</div> 
		</div>
		<div class="mb-0 text-center disclaimer darkBG p-3 row d-flex justify-content-center align-items-center dark-disclaimer-wrap">
			<div class="col-12 col-md-10">
				<small>{{$t('DisclaimerAutoChartist')}}</small>
			</div>
		</div>

    </div>
</template>
<script> 
	import { fxViewMixins } from '@/plugins/fxView'
	import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	import moment from 'moment'
	export default {
		name: 'Trade-News',
		mixins: [fxViewMixins],
		data() {
			return {
				//===========prop in loader component=======
				col_span : 5,
				newsId : '',
				load_more_msz : false,
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false,
				loaderFuncRun : '1',
				//==========================================
				pageLimit : '15',
				search : '',
				page : 1,
				link : ''
			}
		},
		methods:{
			newsTab(getData){
				window.open('https://tradingeconomics.com'+getData);
			},
			detailDiv(index, getData) {
				if(getData == 'more'){
					$(this.$refs['more'+index]).removeClass('hide');
					$(this.$refs['less'+index]).addClass('hide');
				}else{
					$(this.$refs['more'+index]).addClass('hide');
					$(this.$refs['less'+index]).removeClass('hide');
				}             
            },
			loadList(){
				this.page = parseInt(this.page) + 1
				this.listing()
			},
			dateFunction(getDate){
				let last_seen_date = getDate ? moment.utc(getDate, "YYYY-MM-DD HH:mm:ss").fromNow() : '';
				return last_seen_date;
			},
			listing(){
				let inputJson = {
					'globalParams' : {
						filter: {},
						sort: [],
						search: this.search,
						page: this.page,
						perPage: parseInt(this.pageLimit),
					} ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
				}
				this._runGetCurrentNews(inputJson)
			}
		},
		created(){
			if(this.$store.getters[Const.GET_AUTO_CHARTIST] != ''){
				this.loaderFuncRun = '0'
			}
			this.listing()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/tradeNews.vue